export const APP_NAME = 'NKENNEAI Data Portal'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'